import { render, staticRenderFns } from "./PainelBuscaSimplificada.vue?vue&type=template&id=ca8935b0&scoped=true"
import script from "./PainelBuscaSimplificada.vue?vue&type=script&lang=js"
export * from "./PainelBuscaSimplificada.vue?vue&type=script&lang=js"
import style0 from "./PainelBuscaSimplificada.vue?vue&type=style&index=0&id=ca8935b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8935b0",
  null
  
)

export default component.exports